// Comprobante térmico de GASTO / NÓMINA — presentacional puro (oculto en pantalla, visible al imprimir).
// Sprint 42.0 — Espeja el builder ESC/POS (escposHelper.buildGastoTicket) para que Web (Terminal/Valet)
// y 58/80mm impriman idéntico. Incluye dos bloques de firma: ENTREGA y RECIBE. SOLO presentación.
const money = (v) => `$${Number(v || 0).toFixed(2)}`;

export const GastoThermalReceipt = ({ gasto, paperWidth }) => {
  if (!gasto) return null;
  return (
    <div className={`thermal-receipt tr-gasto tr-w${paperWidth}`} data-testid="gasto-thermal">
      <div className="tr-center tr-brand">{gasto.brand || "PARKNOVA"}</div>
      <div className="tr-center tr-bold tr-lg">COMPROBANTE DE GASTO</div>
      {gasto.sucursal ? <div className="tr-row tr-sm"><span>Sucursal:</span><span>{gasto.sucursal}</span></div> : null}
      <div className="tr-row tr-sm"><span>Fecha/Hora:</span><span>{gasto.fecha}</span></div>
      {gasto.operador ? <div className="tr-row tr-sm"><span>Responsable:</span><span>{gasto.operador}</span></div> : null}
      <div className="tr-row tr-sm"><span>Categoría:</span><span>{gasto.categoria || "Otro"}</span></div>
      {gasto.reimpresion ? <div className="tr-center tr-bold tr-sm">** REIMPRESIÓN **</div> : null}
      <div className="tr-sep">--------------------------------</div>

      <div className="tr-bold">CONCEPTO</div>
      <div className="tr-concepto" data-testid="gasto-concepto">{gasto.concepto || "-"}</div>
      <div className="tr-sep">--------------------------------</div>

      <div className="tr-center tr-bold" style={{ marginTop: "4px" }}>IMPORTE ENTREGADO</div>
      <div className="tr-center tr-bold tr-lg" data-testid="gasto-importe">{money(gasto.monto)}</div>
      <div className="tr-sep">--------------------------------</div>

      <div className="tr-bold" style={{ marginTop: "6px" }}>ENTREGA</div>
      {gasto.operador ? <div className="tr-sm">{gasto.operador}</div> : null}
      <div className="tr-sign"><span className="tr-fill" /></div>
      <div className="tr-sm">Nombre y firma</div>

      <div className="tr-bold" style={{ marginTop: "12px" }}>RECIBE</div>
      <div className="tr-sign"><span className="tr-fill" /></div>
      <div className="tr-sm">Nombre</div>
      <div className="tr-sign" style={{ marginTop: "9px" }}><span className="tr-fill" /></div>
      <div className="tr-sm">Firma</div>
    </div>
  );
};

export default GastoThermalReceipt;
